import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Vehicle, PurchaseMethodsV25 } from '@sm360/widget-commons-vehicle';

import 'vdp-used/components/Disclaimer/Disclaimer.scss';

const { DisclaimerAPIService } = PurchaseMethodsV25;

const Disclaimer = ({ legalDisclaimerCz, vehicleDisclaimer }) => {
    const [genericDisclaimers, setGenericDisclaimers] = useState([]);

    useEffect(() => {
        DisclaimerAPIService.getGenericDisclaimers().then((disclaimers) => {
            const specificGenericDisclaimers = [];
            if (disclaimers?.dataResponsibility) specificGenericDisclaimers.push(disclaimers.dataResponsibility);
            if (disclaimers?.priceChange) specificGenericDisclaimers.push(disclaimers.priceChange);

            setGenericDisclaimers(specificGenericDisclaimers);
        });
    }, []);

    return (
        <div className="sr-disclaimer">
            <Vehicle.VehicleDisclaimersContent
                disclaimersContentZone={legalDisclaimerCz}
                genericDisclaimers={genericDisclaimers}
                uniqueDisclaimer={vehicleDisclaimer}
            />
        </div>
    );
};

Disclaimer.defaultProps = {
    legalDisclaimerCz: '',
};

Disclaimer.propTypes = {
    legalDisclaimerCz: PropTypes.string,
    vehicleDisclaimer: PropTypes.string.isRequired,
};

Disclaimer.displayName = 'Disclaimer';

export default Disclaimer;
